import { useState } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { enrichProspects } from '../services/api.js'

export function useProspectEnrichment() {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [result, setResult] = useState(null)
  const queryClient = useQueryClient()

  const enrich = async (requestId, contactIds, quantity, options = {}) => {
    setLoading(true)
    setError(null)
    setResult(null)
    try {
      const data = await enrichProspects(requestId, contactIds, quantity, options)
      setResult(data)
      
      // Invalider les queries pour mettre à jour le solde et la liste des prospects
      queryClient.invalidateQueries({ queryKey: ['credits'] })
      queryClient.invalidateQueries({ queryKey: ['myProspects'] })
      
      return data
    } catch (err) {
      const errorMsg = err?.response?.data?.message || err?.message || 'Erreur d\'enrichissement'
      setError(errorMsg)
      throw new Error(errorMsg)
    } finally {
      setLoading(false)
    }
  }

  const reset = () => {
    setError(null)
    setResult(null)
  }

  return {
    loading,
    error,
    result,
    enrich,
    reset,
  }
}
